import { render, staticRenderFns } from "./HeaderIcon.vue?vue&type=template&id=e2878a5a&"
import script from "./HeaderIcon.vue?vue&type=script&lang=js&"
export * from "./HeaderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2878a5a')) {
      api.createRecord('e2878a5a', component.options)
    } else {
      api.reload('e2878a5a', component.options)
    }
    module.hot.accept("./HeaderIcon.vue?vue&type=template&id=e2878a5a&", function () {
      api.rerender('e2878a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/HeaderIcon.vue"
export default component.exports